'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.of = exports.empty = exports.fromPromise = undefined;

var _fromPromise2 = require('rxjs/observable/fromPromise');

var _empty2 = require('rxjs/observable/empty');

var _of2 = require('rxjs/observable/of');

var fromPromise = exports.fromPromise = _fromPromise2.fromPromise;
var empty = exports.empty = _empty2.empty;
var of = exports.of = _of2.of;


//////////////////
// WEBPACK FOOTER
// ./js/rxjs/observable.js
// module id = 427
// module chunks = 171